let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("fGpBg")).then(() => parcelRequire('6vOy5'));